import { ReactNode, SVGProps } from 'react'
import { TFilterTypes } from '../components/Table/TableFilter/types'
import { PermissionType } from './permissions'
import { SettingsType } from '../utils/hooks/useSystemSettings'

export type FilterVariant =
  | 'string'
  | 'number'
  | 'date'
  | 'range'
  | 'select'
  | 'checkbox'

export type FilterParams = {
  filterVariant?: FilterVariant
  filterField?: string
  filterOptions?: { value: string; label: string; icon?: ReactNode }[]
  defaultFilterValue?: string
  defaultOperatorValue?: TFilterTypes
}

export interface TableColumn {
  id: string
  label: string
  key?: string
  minWidth?: number
  width?: number | string
  sortable?: boolean
  align?: 'right' | 'left' | 'center'
  format?: (value: any, row: any) => ReactNode
  filterParams?: FilterParams
  isStickyLeft?: boolean
  isStickyRight?: boolean
}

export type SVGComponent = (props: SVGProps<SVGSVGElement>) => JSX.Element

export interface Route {
  label: string
  key: string
  notAvailable?: boolean
  subRoutes?: Route[]
  icon: SVGComponent
  permissions?: PermissionType
  settings?: SettingsType[]
}

type ColorTypeKeys = 'black' & 'white' & 'orange' & 'red' & 'grey'

type ColorTypeKeyWeights = 50 &
  100 &
  200 &
  300 &
  400 &
  500 &
  600 &
  700 &
  800 &
  900

type ColorTypeStringWeights = 'light' & 'normal' & 'bold'

export type Colors = {
  [ColorKey in ColorTypeKeys]: Required<
    Record<ColorTypeKeyWeights, `#${string}`> &
      Record<ColorTypeStringWeights, `#${string}`>
  >
}

export enum RouteKeys {
  Shipments = 'shipments',
  Blends = 'blends',
  Flours = 'flours/production-line',
  ProductionLine = 'flours/production-line',
  PostAging = 'flours/post-aging',
  Data = 'data/shipments',
  ShipmentsData = 'data/shipments',
  StorageData = 'data/storage',
  BlendsData = 'data/blends',
  FlourData = 'data/flours',
  BakersData = 'bakers/data',
  SiteDetails = 'settings/site-details',
  EquinomBins = 'settings/equinom-bins',
  WheatCodes = 'settings/wheat-codes',
  WheatProducts = 'settings/wheat/products',
  BakersProducts = 'settings/bakers/products',
  FlourProducts = 'settings/flours',
  Users = 'users',
  DeviceTypes = 'settings/device-types',
  DeviceSN = 'settings/device-sn',
}

export interface PaginationResponseType<T> {
  pagination: {
    limit: number
    offset: number
    total: number
  }
  results: T[]
}

export enum SideNavStateEnum {
  Expanded = 'expanded',
  Shrunk = 'shrunk',
}

export enum EModule {
  Wheat = 'wheat',
  Baker = 'baker',
}
